import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

// Initialize the countries database with English language
countries.registerLocale(enLocale);

export const getCountryName = (countryCode: string): string => {
  return countries.getName(countryCode, 'en') || countryCode;
};
